/**
 * Luxury Design System — scroll reveal
 * Opt-in: add [data-lux-reveal] to any element.
 * Stagger: set --lux-reveal-index inline (0, 1, 2, ...).
 * Respects prefers-reduced-motion and the Theme Editor toggle.
 */
(function () {
  'use strict';

  var root = document.documentElement;

  if (
    !root.classList.contains('lux-animations-enabled') ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !('IntersectionObserver' in window)
  ) {
    // Reveal everything immediately as a safe fallback.
    document.querySelectorAll('[data-lux-reveal]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  function observeAll(scope) {
    (scope || document)
      .querySelectorAll('[data-lux-reveal]:not(.is-revealed)')
      .forEach(function (el) {
        observer.observe(el);
      });
  }

  observeAll();

  // Re-run when the merchant edits sections in the Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });
})();